import { sanitizeHTML } from '@worldcoo/ui/lib/sanitize-html';
import { stripHtml } from '@worldcoo/shared/utils';

// TODO: Rely on deferred Head through react instead of tantstack router to improve load performance
// See https://discord.com/channels/719702312431386674/1406245322044342403
export const Seo = (props: { title?: string; description?: string; image?: string; keywords?: string }) => {
	const description = props.description ? stripHtml(props.description) : undefined;
	return (
		<>
			{props.title && <title>{props.title}</title>}
			{description && <meta name="description" content={sanitizeHTML(description)} />}
			{props.keywords && <meta name="keywords" content={props.keywords} />}
			<meta name="twitter:title" content={props.title} />
			{description && <meta name="twitter:description" content={sanitizeHTML(description)} />}
			<meta name="twitter:creator" content="@worldcoo" />
			<meta name="twitter:site" content="@worldcoo" />
			<meta name="og:type" content="website" />
			<meta name="og:title" content={props.title} />
			{description && <meta name="og:description" content={sanitizeHTML(description)} />}
			{props.image && (
				<>
					<meta name="twitter:image" content={props.image} />
					<meta name="twitter:card" content="summary_large_image" />
					<meta name="og:image" content={props.image} />
				</>
			)}
		</>
	);
};
